import React from "react";
interface IProps {
    NAME: string;
    ID: string;
    DefaultVal?: string;
    ReadOnly?: boolean;
    REF?: any;
    Hidden?: boolean;
    OnChange?: any;
    max?: number;
    min?: number;
    PLACEHOLDER?: string;
}
const CommonSSNInputFields = ({ NAME, ID, REF, DefaultVal }: IProps) => {
    /** Handle the ssn field masking**/
    let keyPressed: number;
    const keyCode = (e: any) => {
        keyPressed = e.keyCode;
    };
    const addMask = (e: any) => {
        e.preventDefault();
        if ((e.target.value.length === 6 || e.target.value.length === 3) && keyPressed != 8 && keyPressed !== 46) {
            e.target.value = e.target.value + "-";
        }
    };
    return <input onKeyDown={keyCode} onChange={addMask} name={NAME} ref={REF} defaultValue={DefaultVal} type="text" className="inputbox" id={ID} maxLength={11} />;
};

const CommonPhoneInputFields = ({ NAME, ID, DefaultVal, ReadOnly, REF, Hidden, OnChange, max, min, PLACEHOLDER }: IProps) => {
    /** Handle the ssn field masking**/
    let keyPressed: number;
    const keyCode = (e: any) => {
        keyPressed = e.keyCode;
    };
    const addMask = (e: any) => {
        e.preventDefault();
        if (e.target.value.length === 1 && keyPressed !== 8 && keyPressed !== 46) {
            e.target.value = "(" + e.target.value;
        } else if (e.target.value.length === 4 && keyPressed !== 8 && keyPressed !== 46) {
            e.target.value = e.target.value + ") ";
        } else if (e.target.value.length === 9 && keyPressed !== 8 && keyPressed !== 46) {
            e.target.value = e.target.value + "-";
        } else if (e.target.value.length === 10 && e.target.value.split("")[0] !== "(") {
            e.target.value = "(" + e.target.value.substring(0, 3) + ") " + e.target.value.substring(3, 6) + "-" + e.target.value.substring(6, 10);
        }

        if (OnChange) {
            OnChange(e);
        }
    };
    return (
        <input
            name={NAME}
            type="text"
            onKeyDown={keyCode}
            onChange={addMask}
            readOnly={ReadOnly ? ReadOnly : false}
            className="inputbox"
            id={ID}
            defaultValue={DefaultVal}
            ref={REF}
            maxLength={max}
            minLength={min}
            hidden={Hidden ? Hidden : false}
            placeholder={PLACEHOLDER ? PLACEHOLDER : "Phone"}
        />
    );
};

export { CommonSSNInputFields, CommonPhoneInputFields };
